module.exports = __webpack_public_path__ + "img/home_menu_14_default.a5daf3ee.png";